import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";

import { LABEL_MAP } from "../constants/medication-label-map";

export const PrescriberMedications = (props) => {
  const { note } = props;

  let medications =
    note.content.medications.length !== 0
      ? note.content.medications
      : [
          {
            adherence: null,
            amount: null,
            benefits: null,
            date: null,
            dosage: null,
            med_changes: null,
            medication_name: null,
            side_effect: null,
          },
        ];

  let content = (
    <>
      <div className="col-12">
        <p className="clr-sec tw:font-bold">Medications</p>
      </div>
      <div
        className="row fs-12"
        style={{ backgroundColor: "#0CD0A7", borderRadius: "5px 5px 0 0", height: 32 }}
      >
        {LABEL_MAP.map((option) => (
          <div
            className={`text-center text-white tw:font-bold col-lg-${option.col} col-12`}
            key={option.key}
          >
            <div className="m-auto">{option.label}</div>
          </div>
        ))}
      </div>

      {medications.map((medication, medIndex) => {
        return (
          <div className="row fs-12" key={medication.medication_name + medIndex}>
            {LABEL_MAP.map((option) => {
              let result = "N/A";

              if (medication[option.key] != null && medication[option.key] !== "") {
                result = medication[option.key];
                if (option.formatter) {
                  result = option.formatter(option, medication);
                }
              }

              return (
                <div className={`col-lg-${option.col} col-12 text-center`} key={option.key}>
                  {result}
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );

  let desktopContent = (
    <CardSecondary className="mx-auto px-3 py-3 d-none d-md-none d-lg-block">
      {content}
    </CardSecondary>
  );

  let mobileContent = (
    <div className="d-block d-md-block d-lg-none mt-3">
      <div className="d-flex justify-content-between">
        <p className="cmt-3 clr-sec tw:font-bold">Current Medications</p>
      </div>

      {medications.map((medication, medIndex) => {
        return (
          <CardSecondary className="mx-auto" key={medication.medication_name + medIndex}>
            <div className="row m-2">
              {LABEL_MAP.map((option) => {
                return (
                  <div
                    className="col-12"
                    key={option.key}
                    style={{ height: 32, overflow: "hidden" }}
                  >
                    {option.label}: {medication[option.key]}
                  </div>
                );
              })}
            </div>
          </CardSecondary>
        );
      })}
    </div>
  );

  return (
    <>
      {desktopContent}
      {mobileContent}
    </>
  );
};
